import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
    CustomersOverviewOnboardingAdminQueryQuery, 
    QueryCustomersOverviewOnboardingAdminArgs 
} from "../../../../../../schemaTypes";

export const CustomersOverviewOnboardingAdminQuery = gql`
  query CustomersOverviewOnboardingAdminQuery(
    $duration: String!
  ) {
    customersOverviewOnboardingAdmin(
      duration: $duration 
    ) {
        accountsCreated
        accountsVerified
        onboarded
        idsConnected
    }
  }
`;

export interface WithCustomersOverviewOnboardingAdmin {
  accountsCreated: number;
  accountsVerified: number;
  onboarded: number;
  idsConnected: number;
}

interface Props {
  variables: QueryCustomersOverviewOnboardingAdminArgs;
  children: (data: WithCustomersOverviewOnboardingAdmin) => React.ReactElement | null;
}

export const CustomersOverviewOnboardingAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    CustomersOverviewOnboardingAdminQueryQuery,
    QueryCustomersOverviewOnboardingAdminArgs
  >(CustomersOverviewOnboardingAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const accountsCreated = data?.customersOverviewOnboardingAdmin?.accountsCreated || 0;
  const accountsVerified = data?.customersOverviewOnboardingAdmin?.accountsVerified || 0;
  const idsConnected = data?.customersOverviewOnboardingAdmin?.idsConnected || 0;
  const onboarded = data?.customersOverviewOnboardingAdmin?.onboarded || 0;

  return children({
        accountsCreated,
        accountsVerified,
        onboarded,
        idsConnected
  });
};